<template>
  <div id="combo-detail">
    <div class="header xs-relative xs-fill-white shadow-down-1 xs-z-100 xs-h-40 md-h-60 lg-static lg-width-auto"
         style="display: none">
      <div class="lg-container xs-flex-center md-justify-start md-items-start xs-relative xs-full-height ">
        <a
          class="xs-flex xs-items-center xs-text-gray-medium xs-absolute xs-l-15 xs-t-0 xs-b-0 xs-opacity-50 close-combo-popup-items"
          href="javascript: void(0);" @click="closeGroup">
          <i class="xs-ml-5 icon-caret-left"></i>
        </a>
        <div class="xs-relative xs-z-500 xs-mx-auto">
          <a class="header-logo xs-block md-pl-30 xs-fill-white lg-fill-none circle" style="padding: 2px;"
             href="javascript: void(0)" @click="$router.push({'name': 'home'})">
            <span class="logo"></span>
          </a>
        </div>
      </div>
    </div>
    <div class="combo-details-breadcrumb hidden-xs hidden-sm">
      <div class="mycontainer">
        <div class="combo-infos">
          <a href="javascript: void(0);"
             @click="back()">
            <i class="glyphicon glyphicon-chevron-left"></i> {{$t('cart.back_to_promo')}}
          </a>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div>
      <div class="combo-details combo-details-header ">
        <div class="mycontainer">
          <div class="combo-image">
            <a href="javascript: void(0);" @click="$root.$emit('onProcessChangeCategory')" type="button"
               class="close close-left pull-left  hidden-lg" data-dismiss="modal" aria-label="Close" style="z-index: 101;"><span
              aria-hidden="true">×</span></a>
            <div class="app-only-deals" v-if="isAppOnly">
              <div class="container-blur"></div>
              <div class="ribbona ribbona-app-only">
                <span>{{ $t('app_only')}} </span>
              </div>
              <img
              v-bind:src="getImageCombo(comboDetails)"
              v-if="!empty(comboDetails) && !empty(comboDetails.image) && comboDetails.image.desktop_detail">
            </div>
            <img
              v-bind:src="getImageCombo(comboDetails)"
              v-else-if="!empty(comboDetails) && !empty(comboDetails.image) && comboDetails.image.desktop_detail">
            <div class="clearfix"></div>
          </div>
          <div class="combo-infos">
            <div class="combo-name heading-hr lg:remove--hr lg:text-left lg:justify-start t30">
              {{comboDetails.name}}
            </div>
            <div class="combo-description">
              <div v-if="comboDetails.marketing_description" v-html="nl2brMethod(comboDetails.marketing_description)" />
            </div>
            <div class="combo-description">
              <div v-if="comboDetails.main_description" v-html="nl2brMethod(comboDetails.main_description)"/>
            </div>
            <div class="" role="button" @click="showAccordionTC = !showAccordionTC" v-if="comboDetails.t_and_c">
              <h6 class="panel-title t14 fw600">
                <i class="fa fa-caret-down" v-if="showAccordionTC"></i>
                <i class="fa fa-caret-up" v-if="!showAccordionTC"></i>
                <span class="pl-5">{{$t('t_and_c')}}</span>
              </h6>
            </div>
            <collapse class="" v-model="showAccordionTC" v-if="comboDetails.t_and_c">
              <div class="menu-description t14" style="color:#d9b084">
                <div v-html="nl2brMethod(comboDetails.t_and_c)"/>
              </div>
            </collapse>
            <div v-if="strikethrough" class="combo-description mt-20 fw600 t20"><span v-if="!isNaN(comboDetails.min_price)" v-html="generatePrice(comboDetails)"></span></div>
            <div v-else class="combo-description mt-20 fw600 t20"><span v-if="!isNaN(comboDetails.display_price)" v-html="generatePrice(comboDetails)"></span></div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <div class="mycontainer-main mycontainer-main--combo-detail">
      <div class="main-content list-item-menu">
        <div class="combo-content">
          <div v-for="(cbgroup,index) in comboDetails.groups" :key="index"
               class="combo-group deal-option--incomplete group-1686 group-index-0"
               v-bind:data-index="index"
               v-bind:class="{open: cbgroup.isOpen, 'current': activeGroup == index, 'done' : cbgroup.done }"
              >
            <div class="combo-group-name t13 pb-10"
                 @click.stop="chooseDetails(cbgroup,index,false,true)">{{cbgroup.name}}
              <div class="combo-group-show">
                <span class="mr-0 ml-5" v-if="cbgroup.done" style="width: 25px; height: 25px;">
                  <img src="https://static.pizzahut.jp/jp/icons/checked_v2.png" style="width: 25px; height: 25px" alt="checked">
                </span>
                <span class="icon mr-0 ml-5"
                       :class="{'icon--add': !cbgroup.isOpen, 'icon--minus': cbgroup.isOpen}"
                       v-else></span>
              </div>
            </div>
            <!-- ############# -->
            <!--begin group combo choosed-->
            <div class="combo-group-description t15  text-grey" data-content="Choose your pizza"
                 v-for="(item,idc) in combogroup" :key="idc" v-if="item.GroupId == cbgroup.id">
              <span class="fw600 hide" v-if="!item.item.id">Choose your pizza</span>
              <div v-if="item.GroupId == cbgroup.id && item.item.id"
                class="combo-group-description--detail">
                <strong class="text-black text-capitalize fw600 detail__name">{{convertString(item.item.name)}}</strong>
                <span class="text-black fw600 t13 detail__price" v-if="item.GroupId == cbgroup.id">+{{$const.CURRENCY}} {{formatNumDisplay(item.item.totalPrice)}}</span>
                <span class="text-black fw600 t13 detail__remove" @click.stop="removeGroup(cbgroup.id)">
                  <i class="pull-right fa fa-times-circle text-ccc" style="font-size: 20px;"></i>
                </span>
              </div>
              <div v-for="addItem in item.item.Add" :key="genUniqueKey(addItem)"
                   v-if="item.GroupId == cbgroup.id && item.item.Add.length > 0 && addItem.special == '1'">
                <span class="cl-78838c text-capitalize t13">{{convertString(addItem.name)}}</span>
                <span class="pull-right text-black fw600 t13 pr20" v-if="addItem.prices">+{{$const.CURRENCY}} {{formatNumDisplay(getPriceTopping(addItem))}}</span>
              </div>
              <div v-for="addItem in item.item.GroupedAdd" :key="genUniqueKey(addItem)"
                   class="detail__topping"
                   v-if="item.GroupId == cbgroup.id && item.item.GroupedAdd && addItem[0].special != '1'">
                <span class="cl-78838c text-capitalize t13">{{$t('cart.add')}}: {{convertString(addItem[0].name)}} x {{Object.keys(addItem).length}}</span>
                <span class="pull-right text-black fw600 t13 pr20" v-if="addItem[0].prices">+{{$const.CURRENCY}} {{formatNumDisplay(getPriceTopping(addItem[0]))}}</span>
              </div>
              <div v-for="noItem in item.item.GroupedRemove" :key="genUniqueKey(noItem)"
                   class="detail__topping"
                   v-if="item.GroupId == cbgroup.id && item.item.GroupedRemove">
                <span class="cl-78838c text-capitalize t13">{{$t('cart.remove')}}: {{convertString(noItem[0].name)}} x {{Object.keys(noItem).length}}</span>
              </div>
            </div>
            <!-- endgroup combo choosed -->

            <!-- ############# -->
            <div class="combo-group-details"
                 :show="cbgroup.isShow">
              <div v-for="(menuItems,indexItem) in cbgroup.item_groups"
                   :key="indexItem">
                <h2 v-if="menuItems.image && cbgroup.isOpen" class="watermark cond caps xs-my-20 xs-mx-10 xs-text-center">
                  <img :src="menuItems.image">
                </h2>
                <div class="combo-group-variants list-item-menu">
                  <div v-for="(menuItem,indexItem) in menuItems.items"
                       :key="indexItem"
                       class="item-menu cols-4 show-detail-modal while-tooltip"
                       data-toggle="tooltip"
                       v-bind:title="menuItem.main_description"
                       style="padding-bottom: 0px;">
                    <combo-pizza-item
                      :item="menuItem"
                      :cbgroupId="cbgroup.id"
                      :iGroup="index"
                      :comboDetails="comboDetails"
                      :comboGroup="combogroup"
                      :isMultiple="isMultiple > 1"
                      v-on:add-to-basket="addToBasket"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="bg-white modal__actions-fixed" v-if="missingGroup || isAppOnly">
        <div class="mycontainer">
          <div class="text-center modal-action-btn">
            <a v-if="isAppOnly" href="javascript:void(0)" @click="() => openAppOnlyDeal(linkAppOnly)" type="button" class="btn btn-danger btn-add-to-cart" style="text-align: center;">
              <span>{{$t('get_the_app_now')}}</span>
            </a>
            <div v-else type="button" class="btn btn--primary btn-add-to-cart" @click="addTocart()" style=""><span
              class="pull-left">{{$t('button_add_to_cart')}}</span> <span class="pull-right combo-price">+{{$const.CURRENCY}} {{formatNumDisplay(totalPrice)}}</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style lang='scss' scoped>
  @import '../../assets/css/combo_details.css';
</style>
<script type="text/javascript">
import ModalCombo from '../popup/ModalCombo.vue'
import ComboPizzaItem from './ComboPizzaItem.vue'
import DispositionPopup from '../home/HomeLocalizationMapZipcodeNewDesign'
import * as types from '@/store/types'
import {mapGetters, mapActions} from "vuex";

export default {
  components: {
    ComboPizzaItem
  },
  mounted() {
    let vm = this
    this.$cart.init(this)

    if(document.documentElement.clientWidth < 768){
      document.body.classList.add('mobile')
    }

    const dataParams = {
      name: this.$route.name,
      params: this.$route.params
    }
    if (!this.checkPosition(this)) {
      // this.$router.push({'name': 'home'})
      this.$modal.show(DispositionPopup, {isPopup: true, currentPath: dataParams}, {class: 'modal-localization'})
    } else {
      if (this.$route.params.coupon) {
        this.coupon = this.$route.params.coupon
        let item = this.$cart.get(this)
        if (!item.current_coupon_item || item.current_coupon_item.uuid != this.$route.params.nameseo || item.current_coupon_item.coupon != this.$route.params.coupon) {
          this.$root.$emit('onProcessChangeCategory')
        }
        this.getComboDetailsFreeItem(item.current_coupon_item.menu[0])
      } else {
        this.getComboDetails()
      }
      this.$root.$on('triggerLoadDealDetail', (id) => {
        let comboDetails = this._.cloneDeep(this.comboDetails)
        comboDetails.isMultiple = this.isMultiple > 1
        vm.eventTrackingProductDetail(this, comboDetails, this.$const.CARD_ITEM_TYPE.COMBO, 'product-details')
        for (let j in vm.comboDetails.groups) {
          if (this.comboDetails.groups[j].id == id) {
            this.eventTrackingModuleLoadDeal(this, this.comboDetails.groups[j]);
            break
          }
        }
      })

      this.$root.$on('responseComboGroup', (obj, id) => {
        vm.changeCombo(obj, id)
        vm.mountedDone = true
        vm.checkMissingGroup()
        vm.calTotalPrice()
        vm.closeGroup(id)
      })
    }
  },
  destroyed() {
    this.setUuidForNameseoDuplicate('')
    this.$root.$emit('closeModalPizzaCombo')
    this.$root.$off('triggerLoadDealDetail')
  },
  updated() {
    let vm = this

    if (vm.mountedDone) {
      this.scrollToOpenedGroup()
    }
  },
  methods: {
    ...mapActions({
      setSelectedCategory: types.SET_SELECTED_CATEGORY,
      setUuidForNameseoDuplicate: types.SET_UUID_FOR_NAMESEO_DUPLICATE
    }),
    getImageCombo (comboDetails) {
      if (this.isMobile()) {
        return (comboDetails.image && comboDetails.image.mobile_detail) ? comboDetails.image.mobile_detail : this.$const.IMG_PIZZA_DEFAULT
      } else {
        return (comboDetails.image && comboDetails.image.desktop_detail) ? comboDetails.image.desktop_detail : this.$const.IMG_PIZZA_DEFAULT
      }
    },
    hasSelection(item) {
      if (item && item.first_layers && item.first_layers !== undefined) {
        return item.first_layers.length > 1 || item.first_layers.length == 1 && item.first_layers[0].second_layers.length > 1
      }
      return false
    },
    getMinPrice (item) {
      let price = item.price || 0
      if (item && item.first_layers && item.first_layers !== undefined && item.first_layers.length === 1) {
        price += item.first_layers[0].price || 0
        if (item.first_layers[0].second_layers.length === 1) {
          price += item.first_layers[0].second_layers[0].price || 0
        }
      }
      return price
    },
    /**
     * Get topping price
     * */
    getPriceTopping(add) {
      for (let i in this.combogroup) {
        let obj = this.combogroup[i].item
        for (let o in obj.Add) {
          if (obj.Add[o].uuid == add.uuid) {
            return add.prices[obj.choosedFirst.sku] ? add.prices[obj.choosedFirst.sku] * Object.keys(obj.GroupedAdd[add.uuid]).length : 0
          }
        }
      }

      return 0
    },
    changeCombo(obj, id) {
      // update choosed item in Group
      for (let i in this.combogroup) {
        for (let o in obj) {
          if (this.combogroup[i].GroupId == obj[o].GroupId) {
            this.combogroup[i]['item'] = obj[o].item
            this.$forceUpdate(this.combogroup[i], 'item', obj[o].item)
          }
        }
      }

      // mark 'DONE'
      for (let j in this.comboDetails.groups) {
        if (this.comboDetails.groups[j].id == id) {
          this.comboDetails.groups[j].done = true
        }
      }

      // find not 'DONE' item yet, and open that
      for (let k in this.comboDetails.groups) {
        if (this.comboDetails.groups[k] == id) {
          this.comboDetails.groups[k]['isOpen'] = false
          this.comboDetails.groups[k]['isShow'] = false
          continue
        } else {
          if (this.comboDetails.groups[k].done == undefined || !this.comboDetails.groups[k].done) {
            this.comboDetails.groups[k]['isOpen'] = true
            this.comboDetails.groups[k]['isShow'] = true
            break
          } else {
            this.comboDetails.groups[k]['isOpen'] = false
            this.comboDetails.groups[k]['isShow'] = false
          }
        }
      }
    },
    getComboDetails () {
      let vm = this

      let nameSeo = this.$route.params.nameseo
      console.log('this.$route.params: ', this.$route.params);
      let data = {
        'friendly_seo_name': nameSeo,
        'tier': this.$disposition.getByKey(this, 'tier', '1'),
        'order_type': this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        'outlet_code': this.$disposition.getByKey(this, 'outletCode', null),
        'order_time': this.convertSecond(this.convertDateTimeToUTC(this.$disposition.getByKey(this, 'collectionTimeText', '')))
      }
      this.axios.getComboDetailsFriendlyNameSeo(data, function (response) {
        // in case api have not name seo from edit cart or free item, that will call old api with uuid then handle same response
        if (response.data.error) {
          let uuid = vm.uuidForNameseoDuplicate || nameSeo
          // duplicate friendly name seo
          if (response.data.error.code === vm.$const.DUPLICATE_FRIENDLY_NAME_SEO && !vm.uuidForNameseoDuplicate) {
            vm.$notify({
              type: 'error',
              title: vm.$t('invalid_item')
            })
            vm.redirectToMenuPage()
          } else {
            vm.getComboDetailWithUuid(uuid)
          }
        } else {
          vm.handleResponseData(response, data)
        }
      })
    },
    getComboDetailWithUuid (uuid) {
      let vm = this

      let dataWithUUid = {
        'tier': this.$disposition.getByKey(this, 'tier', '1'),
        'order_type': this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        'outlet_code': this.$disposition.getByKey(this, 'outletCode', null),
        'order_time': this.convertSecond(this.convertDateTimeToUTC(this.$disposition.getByKey(this, 'collectionTimeText', '')))
      }
      this.axios.getComboDetails(uuid, dataWithUUid, function (response) {
        vm.handleResponseData(response, dataWithUUid)
      })
    },
    handleResponseData (response, data) {
      let vm = this
      if (!response.data.status) {
        if (response.data.error) {
          vm.$notify({
            type: 'error',
            title: response.data.error.message || vm.$t('invalid_item')
          })
        }
        vm.redirectToPage(vm.$const.SLUG_LIST.DEAL)
      } else {
        vm.comboDetails = response.data.data.item
        vm.isAppOnly = vm.getValueFromAttr(vm.comboDetails, 'customize.promote_for_download_app', false)
        vm.linkAppOnly = vm.getValueFromAttr(vm.comboDetails, 'customize.deep_link_download_app', '')
        const selectedCategory = vm.categoryList.filter(item => {
          return vm.getValueFromAttr(vm.comboDetails, 'display_categories.0.uuid') === item.uuid
        })
        vm.setSelectedCategory(selectedCategory.length > 0 ? selectedCategory[0] : null)
        if (vm.empty(vm.comboDetails)) {
          vm.$notify({
            type: 'error',
            title: vm.$t('combo_detail_notfound')
          })
          vm.$root.$emit('onProcessChangeCategory')
          return false
        }
        if (document.getElementsByTagName('meta')['description'] === undefined) {
          let meta = document.createElement('meta')
          meta.setAttribute('name', 'description')
          meta.setAttribute('content', vm.comboDetails.marketing_description || '')
          document.head.appendChild(meta)
        } else {
          let descriptionEl = document.getElementsByTagName('meta')['description']
          descriptionEl.content = vm.$t('description_detail_menu', {name: vm.comboDetails.name_en || '', des: vm.comboDetails.marketing_description || ''})
        }
        document.title = vm.$t('title_detail_menu', {title: vm.comboDetails.name_en || ''})
        //Add data for cart item
        vm.$cart.tier = data.tier
        vm.$cart.order_type = data.order_type
        //Add data for cart item
        vm.getComboGroup()
        let comboDetails = vm._.cloneDeep(vm.comboDetails)
        comboDetails.isMultiple = vm.isMultiple > 1
        vm.eventTrackingProductDetail(vm, comboDetails, vm.$const.CARD_ITEM_TYPE.COMBO, 'product-details')
        vm.checkMissingGroup()
        vm.autoAddItemGroup()
        //vm.comboDetails.groups[0].isOpen = true
        vm.autoOpenGroup()
      }
    },
    /**
     * Automatic open group combo
     */
    autoOpenGroup () {
      for (let i in this.comboDetails.groups) {
        if (this.comboDetails.groups[i].items.length == 1 && !this.hasSelection(this.comboDetails.groups[i].items[0])) {
        } else {
          this.eventTrackingModuleLoadDeal(this, this.comboDetails.groups[i])
          break
        }
      }
    },
    getComboDetailsFreeItem(item) {
      this.comboDetails = item
      this.getComboGroup()
      this.checkMissingGroup()
    },
    closeGroup(groupID) {
      for (let i in this.comboDetails.groups) {
        if (this.comboDetails.groups[i] == groupID) {
          this.comboDetails.groups[i]['isShow'] = false
          this.comboDetails.groups[i]['isOpen'] = false
        }
      }

      this.activeGroup = null
      document.body.classList.remove('combo-popup-items')
    },
    triggerChoosingTopping() {
      this.$store.dispatch({
        type: 'setTriggerChoosingTopping',
      })
    },
    choosePizza(obj, id) {
      this.$modal.show(ModalCombo, {
        menu: obj,
        sizecrust: this.comboDetails.sizecrustimages,
        extracheese: this.comboDetails.extracheese,
        cGroup: JSON.parse(JSON.stringify(this.combogroup)),
        id: id,
        comboUUID: this.$route.params.id,
        comboName: this.comboDetails.name,
        displayCategory: this.comboDetails.display_categories || ''
      }, {class: 'modal-menu', transition: 'nice-modal-fade', overlayTransition: 'overlay-fade'}, {
        'before-open': this.beforeOpen,
        'before-close': this.beforeClose
      })
    },
    chooseDetails(obj, index, autoSelect = false, clicked = false) {
      let isMobile = false
      if(document.documentElement.clientWidth < 768){
        isMobile = true
      }
      /*if (this.activeGroup == index && document.body.classList.contains('combo-popup-items') && document.documentElement.clientWidth < 768) {
        return false
      }*/

      obj.isOpen = !obj.isOpen

      //this.$set(obj, 'isShow', !obj.isShow)
      this.activeGroup = index

      if (!obj.isOpen) {
        // document.body.classList.remove('combo-popup-items')
        this.activeGroup = null
      } else {
        this.eventTrackingModuleLoadDeal(this, this.comboDetails.groups[index])
        if(!autoSelect){
          // document.body.classList.add('combo-popup-items')
        }
      }

      if (this.comboDetails.groups[index].items.length === 1
        && obj.isOpen
        && clicked
      ) {
        let pizza = this.comboDetails.groups[index].items[0]
        let comboDetailId = this.comboDetails.groups[index].id

        this.choosePizza(pizza, comboDetailId)
        this.triggerChoosingTopping()
      }
    },
    /**
     * Trigger before open modal popup
     * */
    beforeOpen(event) {
      document.body.classList.add('modal-open')
    },
    /**
     * Trigger before close modal popup
     * */
    beforeClose(event) {
      document.body.classList.remove('modal-open')
    },
    getComboGroup() {
      let vm = this
      vm.comboDetails.groups.map((combo) => {
        vm.autoAddItemDefault(combo)
        if (combo.min === 0) {
          vm.min++
        }
      })
      let single_type = []
      for (let index_single_type in vm.comboDetails.single_types ) {
        let data = {}
        data.id = vm.comboDetails.single_types[index_single_type].id
        data.image = vm.comboDetails.single_types[index_single_type].image ? vm.comboDetails.single_types[index_single_type].image.banner : ''
        data.items = []
        let check = single_type.filter(function(s){
          return s.id == data.id
        })
        if(check && check.length > 0) {continue}
        else {single_type.push(data)}
      }

      for (let gr in this.comboDetails.groups) {
        // auto open 1st group
        if (gr == 0 && !vm.isDefault) {
          this.comboDetails.groups[gr].isOpen = true
          this.comboDetails.groups[gr].isShow = true
        }
        vm.isMultiple = vm.comboDetails.groups.length
        for (let indexGroup in vm.comboDetails.groups) {
          let itemNotHaveSingleTypes = []
          let single = {
            items: []
          }
          vm.comboDetails.groups[indexGroup].item_groups = []
          for (let indexItem in vm.comboDetails.groups[indexGroup].items) {
            const obj = vm.comboDetails.groups[indexGroup].items[indexItem]
            if (vm.getValueFromAttr(obj, 'first_layers', []).length > 0 && vm.getValueFromAttr(obj, 'single_types', []).length > 0) {
              for (let indexSingleType in single_type) {
                if (single_type && single_type.length > 0 && vm.getValueFromAttr(obj, 'single_types.0.id') == single_type[indexSingleType].id) {
                  single_type[indexSingleType].items.push(obj)
                }
              }
            } else {
              itemNotHaveSingleTypes.push(obj)
            }
          }
          if (itemNotHaveSingleTypes && itemNotHaveSingleTypes.length > 0) {
            for (let indexItem = 0; indexItem < itemNotHaveSingleTypes.length; indexItem++) {
              single.items.push(itemNotHaveSingleTypes[indexItem])
            }
            vm.comboDetails.groups[indexGroup].item_groups.push(single)
          }
          if (single_type && single_type.length > 0 ) {
            for (let i in single_type) {
              if(single_type[i].items.length > 0) {
                let data = Object.assign({}, single_type[i], {})
                vm.comboDetails.groups[indexGroup].item_groups.push(data)
              }
              single_type[i].items = []
            }
          }
        }
        // vm.combogroup.push({
        //   'GroupUUID': vm.comboDetails.groups[gr].uuid,
        //   'GroupId': vm.comboDetails.groups[gr].id,
        //   'min': vm.comboDetails.groups[gr].min,
        //   'item': {}
        // })
        if (vm.combogroup.length <= 0) {
          vm.combogroup.push({
            'GroupUUID': vm.comboDetails.groups[gr].uuid,
            'GroupId': vm.comboDetails.groups[gr].id,
            'min': vm.comboDetails.groups[gr].min,
            'item': {}
          })
        } else {
          let checkDuplicate = false
          vm.combogroup.map(combo => {
            if (combo.GroupId === vm.comboDetails.groups[gr].id) {
              checkDuplicate = true
            }
          })
          if (!checkDuplicate) {
            vm.combogroup.push({
              'GroupUUID': this.comboDetails.groups[gr].uuid,
              'GroupId': this.comboDetails.groups[gr].id,
              'min': this.comboDetails.groups[gr].min,
              'item': {}
            })
          }
        }
      }
    },
    checkMissingGroup() {
      let group = this._.cloneDeep(this.comboDetails.groups)
      let groupItem = 0
      group.map(function (grp) {
        if(grp.min > 0)
          groupItem++
      })
      let addItem = 0
      for (let k in this.combogroup) {
        if (this.combogroup[k].item.name !== undefined && this.combogroup[k].item.name.length > 0 && this.combogroup[k].min > 0) {
          addItem++
        }
      }
      this.missingGroup = (addItem >= groupItem)
    },
    calTotalPrice() {
      let total = 0
      this.totalPrice = 0
      total += parseFloat(this.comboDetails.price)
      for (let k in this.combogroup) {
        // total += parseFloat(this.combogroup[k].item.totalPrice)
        if (this.combogroup[k] && this.combogroup[k].item && this.combogroup[k].item.totalPrice) {
          total += parseFloat(this.combogroup[k].item.totalPrice)
        }
      }
      this.totalPrice = total
    },
    removeGroup(id) {
      for (let k in this.combogroup) {
        if (this.combogroup[k].GroupId == id) {
          this.combogroup[k]['item'] = {}
        }
      }
      for (let j in this.comboDetails.groups) {
        if (this.comboDetails.groups[j].id == id) {
          this.comboDetails.groups[j].done = false
        }
      }
      this.checkMissingGroup()
      this.calTotalPrice()
    },
    /*
      Set the default item in the combo BA20-893
      * input: combo group
      * output: single have defaut = 1
     */
    autoAddItemDefault (comboGroup) {
      let vm = this
      for (let itemIndex = 0; itemIndex < comboGroup.items.length; itemIndex++) {
        if (!comboGroup.items[itemIndex].default) continue
        let menu = this._.cloneDeep(comboGroup.items[itemIndex])
        menu.first_layers = []
        vm.isDefault = true
        for (let firstIndex = 0; firstIndex < comboGroup.items[itemIndex].first_layers.length; firstIndex++) {
          if (!comboGroup.items[itemIndex].first_layers[firstIndex].default) continue
          menu.first_layers.push(this._.cloneDeep(comboGroup.items[itemIndex].first_layers[firstIndex]))
          menu.first_layers[0].second_layers = []
          
          for (let secondIndex = 0; secondIndex < comboGroup.items[itemIndex].first_layers[firstIndex].second_layers.length; secondIndex++) {
            if (!comboGroup.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].default) continue
            menu.first_layers[0].second_layers.push(comboGroup.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex])
          }
        }
        
        this.combogroup.push({
          'GroupUUID': comboGroup.uuid,
          'GroupId': comboGroup.id,
          'min' : comboGroup.min,
          'item': {}
        })
        this.addToBasket(menu, comboGroup.id)
      }
    },
    addToBasket(menu, groupID, idx) {
      let vm = this
      if (!menu) {
        return false
      }

      const { size, crust } = this.getBothSelectedSizeNCrust

      let firstSelected = {}
      let secondSelected = {}
      let price = 0

      price += parseFloat(menu.price > 0 ? menu.price : 0)
      if (menu.first_layers && menu.first_layers.length > 0) {
        firstSelected = !this._.isEmpty(size) ? size : menu.first_layers[0]

        price += parseFloat(firstSelected.price > 0 ? firstSelected.price : 0)

        if (firstSelected.second_layers && firstSelected.second_layers.length > 0) {
          secondSelected = !this._.isEmpty(crust) ? crust : firstSelected.second_layers[0]
          price += parseFloat(secondSelected.price > 0 ? secondSelected.price : 0)
        }
      }

      let cGroup = JSON.parse(JSON.stringify(this.combogroup))
      let categoryNameObject = (menu.category && menu.category.name) ? menu.category.name : ''
      let categoryName = categoryNameObject.en || ''
      for (let cb in cGroup) {
        if (cGroup[cb].GroupId == groupID) {
          cGroup[cb].item.name = menu.name + ' ' + (firstSelected.name != undefined ? firstSelected.name : '')
          cGroup[cb].item.id = menu.id
          cGroup[cb].item.choosedSecond = secondSelected
          cGroup[cb].item.choosedFirst = firstSelected
          cGroup[cb].item.price = price
          cGroup[cb].item.totalPrice = price
          cGroup[cb].item.Default = []
          cGroup[cb].item.Remove = []
          cGroup[cb].item.Add = []
          cGroup[cb].item.uuid = menu.uuid
          cGroup[cb].item.CheesePrice = 0
          cGroup[cb].item.image = menu.image.desktop_thumbnail
          cGroup[cb].item.category = categoryName
        }
      }
      this.closeGroup(groupID)
      let pro = {
        item: menu,
        id: menu.uuid,
        uuid: menu.uuid,
        combo_uuid: this.comboDetails.uuid,
        name: menu.name,
        price: price,
        first: firstSelected || {},
        second: secondSelected || {},
        display_categories: this.comboDetails.display_categories
      }
      this.eventTrackingAddToDeal(this, pro)
      // reset state selected Size&Crust in STORE
      this.$store.dispatch(types.REMOVE_SELECTED_SIZE_N_CRUST)
      this.$root.$emit('responseComboGroup', cGroup, groupID)
    },
    trackEventProductClick (pro) {
      let variantUUid = ''
      if (!this.empty(pro.first) && pro.first.uuid != '') {
        variantUUid = pro.first.uuid
      }

      if (!this.empty(pro.second) && pro.second.uuid != '') {
        variantUUid += '-' + pro.second.uuid
      }
      let proClick = this._.cloneDeep(pro.item)
      proClick.variant_uuid = variantUUid
      this.evenTrackingProductClick(this, proClick, 'product-selection-from-variant-list-main-pizza-list')
    },
    generatePrice (item) {
      if (this.strikethrough)
        return this.$t('format_currency', { prefix: this.$t('from'), currency: this.$const.CURRENCY, amount: this.formatNumDisplay(item.min_price), start: '<span class="t13"><span class="font-08em cl-78838c fw-normal">', end: '</span></span>' })
      else
        return this.$t('format_currency', { prefix: this.$t('from'), currency: this.$const.CURRENCY, amount: this.formatNumDisplay(item.display_price), start: '<span class="t13"><span class="font-08em cl-78838c fw-normal">', end: '</span></span>' })
    },
    checkVariable (variable) {
      return variable === '1' || variable === 1 || variable === true || variable === 'true'
    },
    addTocart() {
      let item = {
        'group': {},
        'selling_start': this.comboDetails.selling_start,
        'products': []
      }
      if (this.coupon) {
        item.group.coupon_code = this.coupon
      }
      item.group['outlet_code'] = this.getOutletCode(this)
      item.group['tier'] = this.$cart.tier
      item.group['order_type'] = this.$cart.order_type
      item.group['order_time'] = this.getTimePickerDate(this)
      item.group['product_type'] = this.$const.CARD_ITEM_TYPE.COMBO
      item.group['combo_id'] = this.comboDetails.uuid
      item.group['quantity'] = 1
      item.group['category_uuid'] = this.$store.getters.category_uuid

      let pro = {
        items: [],
        item: this.comboDetails,
        id: this.comboDetails.uuid,
        name: this.comboDetails.name,
        price: this.totalPrice,
        context: 'product'
      }
      for (let i in this.combogroup) {
        let obj = this.combogroup[i].item
        let product = {}
        if (this._.isEmpty(obj)) continue
        product.category_id = null
        product.combo_group_id = this.combogroup[i].GroupUUID
        product.product_id = obj.uuid
        product.first_id = obj.choosedFirst.uuid
        product.second_id = obj.choosedSecond.uuid
        product.toppings = {}
        product.toppings.remove = this.$cart.getToppingById(obj.Remove)
        product.toppings.extra = this.$cart.getToppingById(obj.Add)
        item.products.push(product)
        pro.items.push({
          item: obj,
          first: obj.choosedFirst,
          second: obj.choosedSecond
        })
      }
      if (!this.$route.params.ssid || this.$route.params.ssid == 'coupon') {
        this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.COMBO)
        this.$cart.insert(this, item)
      } else {
        item.group['item_id'] = this.$route.params.ssid
        this.$cart.updateCart(this, item)
      }
      this.$cart.clearFreeItem(this)
      this.$root.$emit('onProcessChangeCategory')
      if (this.coupon) {
        this.$router.push({name: 'category', params: { slug: 'coupons' }})
      }
    },
    getImage(data) {
      if (!this.empty(data) && data.image.length > 0) {
        return data.image[0].icon
      }
      return ''
    },
    /*
      Automatic add item when the group only 1 item
     */
    autoAddItemGroup() {
      let vm = this
      let isCombo = true

      for (let i of this.comboDetails.groups) {
        if (i.items.length == 1 && !this.hasSelection(i.items[0]) && i.min > 0) {
          if (vm.isPizzaItem(i.items[0], isCombo)) {
            this.$store.dispatch(types.SET_SELECTED_SIZE, i.items[0].first_layers[0])
            this.$store.dispatch(types.SET_SELECTED_CRUST, i.items[0].first_layers[0].second_layers[0])
          }

          this.addToBasket(i.items[0], i.id)
        }
      }
    },
    generateMinPrice(item) {
      return this.$t('format_currency_combo_detail', {
        prefix: this.$t('from'),
        currency: this.$const.CURRENCY,
        amount: this.formatNumDisplay(item.min_price),
        start: '<span class="t13"><span class="font-08em cl-78838c fw-normal">',
        end: '</span></span>'
      })
    },
    scrollToOpenedGroup() {
      let openedGroup = document.querySelectorAll('.combo-group.open').item(0)
      if (openedGroup) {
        openedGroup.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        })
      }
    },
  },
  data() {
    return {
      showAccordionTC: false,
      isMultiple: 0,
      combogroup: [],
      missingGroup: false,
      activeGroup: false,
      totalPrice: 0,
      coupon: '',
      comboDetails: {},
      mountedDone: false,
      isDefault: false,
      isAppOnly: false,
      linkAppOnly: '',
      strikethrough: ''
    }
  },
  computed: {
    ...mapGetters({
      categoryList: 'categoryList',
      getSelectedSize: types.GET_SELECTED_SIZE,
      getSelectedCrust: types.GET_SELECTED_CRUST,
      getBothSelectedSizeNCrust: types.GET_BOTH_SELECTED_SIZE_N_CRUST,
      uuidForNameseoDuplicate: 'getUuidForNameseoDuplicate',
      configTenant: types.GET_CONFIG_TENANT
    })
  },
  watch: {
    missingGroup(newValue, oldValue) {
      if (newValue) {
        let pro = {
          combogroup: this.combogroup,
          item: this.comboDetails,
          price: this.totalPrice
        }
        this.eventTrackingProductView(null, pro, this)
      }
    },
    configTenant: function () {
      this.strikethrough = this.checkVariable(this.configTenant.enable_combo_strikethrough_web ? this.configTenant.enable_combo_strikethrough_web : 0)
    }
  }
}
</script>
<style>
  .modal__actions-fixed {
    -webkit-box-shadow: 0 0 20px 5px rgba(0, 0, 0, .05);
    -webkit-transform: translateZ(0);
    background: #fff;
    bottom: 0;
    box-shadow: 0 0 20px 5px rgba(0, 0, 0, .05);
    height: auto;
    left: 0;
    padding: 5px;
    position: fixed;
    right: 0;
    z-index: 10;
  }

  .watermark img {
    width: 320px;
  }
  @media only screen and (min-width: 640px) {
    .watermark img {
      width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/combo/ComboDetail.vue